(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("bYadz", function(module, exports) {

$parcel$export(module.exports, "entry_encode", function () { return $8b6d395814534b36$export$f36491c978b47831; });
$parcel$export(module.exports, "entry_decode", function () { return $8b6d395814534b36$export$4537221bf74c4819; });
$parcel$export(module.exports, "entry_fromJson", function () { return $8b6d395814534b36$export$6f3f41cc52acf41c; });
$parcel$export(module.exports, "entry_toJson", function () { return $8b6d395814534b36$export$50fd5e4354593993; });
$parcel$export(module.exports, "t_encode", function () { return $8b6d395814534b36$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "t_decode", function () { return $8b6d395814534b36$export$bb5e712207166a02; });
$parcel$export(module.exports, "make", function () { return $8b6d395814534b36$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "fromJson", function () { return $8b6d395814534b36$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $8b6d395814534b36$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "abstract_encode", function () { return $8b6d395814534b36$export$e5172b961a11c52e; });
$parcel$export(module.exports, "abstract_decode", function () { return $8b6d395814534b36$export$bdddd0cc5d922103; });
$parcel$export(module.exports, "toStringOfIndex", function () { return $8b6d395814534b36$export$e3ea025983b032e1; });
$parcel$export(module.exports, "codec", function () { return $8b6d395814534b36$export$1c37c01eba8ed446; });
$parcel$export(module.exports, "safeDecode", function () { return $8b6d395814534b36$export$7a47376c130cfeac; });
$parcel$export(module.exports, "fromString", function () { return $8b6d395814534b36$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $8b6d395814534b36$export$f84e8e69fd4488a5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $3zjNo = parcelRequire("3zjNo");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $i7mYY = parcelRequire("i7mYY");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $gTtop = parcelRequire("gTtop");

var $kiuDo = parcelRequire("kiuDo");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");
function $8b6d395814534b36$export$f36491c978b47831(v) {
    return $d3YYW.fromArray([
        [
            "facet",
            $3zjNo.stringToJson(v.facet)
        ],
        [
            "index",
            $3zjNo.intToJson(v.index)
        ]
    ]);
}
function $8b6d395814534b36$export$4537221bf74c4819(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var facet = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "facet"), null));
    if (facet.TAG === /* Ok */ 0) {
        var index = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "index"), null));
        if (index.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                facet: facet._0,
                index: index._0
            }
        };
        var e = index._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".index" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = facet._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".facet" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $8b6d395814534b36$export$6f3f41cc52acf41c = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "facet", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "index", $jVmMx.Decode.$$int), function(facet, index) {
    return {
        facet: facet,
        index: index
    };
});
function $8b6d395814534b36$export$50fd5e4354593993(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "facet",
            $iv6Yc._1($jVmMx.Encode.string, param.facet)
        ],
        [
            "index",
            $iv6Yc._1($jVmMx.Encode.$$int, param.index)
        ]
    ]);
}
function $8b6d395814534b36$export$cc42ff7b6c615091(v) {
    return $d3YYW.fromArray([
        [
            "entries",
            $3zjNo.arrayToJson($8b6d395814534b36$export$f36491c978b47831, v.entries)
        ],
        [
            "minPrice",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.minPrice)
        ],
        [
            "maxPrice",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.maxPrice)
        ]
    ]);
}
function $8b6d395814534b36$export$bb5e712207166a02(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var entries = $3zjNo.arrayFromJson($8b6d395814534b36$export$4537221bf74c4819, $2whNH.getWithDefault($d3YYW.get(dict$1, "entries"), null));
    if (entries.TAG === /* Ok */ 0) {
        var minPrice = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "minPrice"), null));
        if (minPrice.TAG === /* Ok */ 0) {
            var maxPrice = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "maxPrice"), null));
            if (maxPrice.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    entries: entries._0,
                    minPrice: minPrice._0,
                    maxPrice: maxPrice._0
                }
            };
            var e = maxPrice._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maxPrice" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = minPrice._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".minPrice" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = entries._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".entries" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function $8b6d395814534b36$export$dd44f18ab656f3bb(minPrice, maxPrice, entries) {
    return {
        entries: entries,
        minPrice: minPrice,
        maxPrice: maxPrice
    };
}
var $8b6d395814534b36$export$7ae2d2a8b28a8cb8 = $79vie.map3($79vie.field("entries", $79vie.array($8b6d395814534b36$export$6f3f41cc52acf41c)), $79vie.field("minPrice", $79vie.option($79vie.$$float)), $79vie.field("maxPrice", $79vie.option($79vie.$$float)), function(entries, minPrice, maxPrice) {
    return {
        entries: entries,
        minPrice: minPrice,
        maxPrice: maxPrice
    };
});
function $8b6d395814534b36$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "entries",
            $iv6Yc._2($jVmMx.Encode.array, param.entries, $8b6d395814534b36$export$50fd5e4354593993)
        ],
        [
            "minPrice",
            $jVmMx.Encode.nullable(param.minPrice, $jVmMx.Encode.$$float)
        ],
        [
            "maxPrice",
            $jVmMx.Encode.nullable(param.maxPrice, $jVmMx.Encode.$$float)
        ]
    ]);
}
var $8b6d395814534b36$export$e5172b961a11c52e = $3zjNo.stringToJson;
var $8b6d395814534b36$export$bdddd0cc5d922103 = $3zjNo.stringFromJson;
function $8b6d395814534b36$var$t_decode$1(json) {
    return $gTtop.flatMap($3zjNo.stringFromJson(json), function(string) {
        var entries = $i7mYY.keepMap(string.split(","), function(each) {
            var match = each.split(";");
            if (match.length !== 2) return {
                facet: decodeURIComponent(each),
                index: -1
            };
            var key = match[0];
            var index = match[1];
            return {
                facet: decodeURIComponent(key),
                index: $kiuDo.int_of_string(index)
            };
        });
        var extractedMinPrice = $i7mYY.reduce(entries, undefined, function(acc, entry) {
            var match = entry.facet.split("=");
            if (match.length !== 2) return acc;
            var match$1 = match[0];
            if (match$1 === "minprice") return $d1G6W.fromString(match[1]);
            else return acc;
        });
        var extractedMaxPrice = $i7mYY.reduce(entries, undefined, function(acc, entry) {
            var match = entry.facet.split("=");
            if (match.length !== 2) return acc;
            var match$1 = match[0];
            if (match$1 === "maxprice") return $d1G6W.fromString(match[1]);
            else return acc;
        });
        var entries$1 = $i7mYY.keepMap(entries, function(entry) {
            var match = entry.index;
            if (match !== -1) return entry;
        });
        return {
            TAG: /* Ok */ 0,
            _0: {
                entries: entries$1,
                minPrice: extractedMinPrice,
                maxPrice: extractedMaxPrice
            }
        };
    });
}
function $8b6d395814534b36$var$encode(a) {
    return JSON.stringify($3zjNo.stringToJson(a.join(","))).replace(/^\"(.*)\"$/, "$1");
}
function $8b6d395814534b36$var$t_encode$1(a) {
    return $8b6d395814534b36$var$encode($i7mYY.concat($i7mYY.map(a.entries, function(param) {
        return encodeURIComponent(param.facet) + ";" + String(param.index);
    }), $i7mYY.keepMap([
        $2whNH.map(a.minPrice, function(minPrice) {
            return encodeURIComponent("minprice") + "=" + String(minPrice);
        }),
        $2whNH.map(a.maxPrice, function(maxPrice) {
            return encodeURIComponent("maxprice") + "=" + String(maxPrice);
        })
    ], function(a) {
        return a;
    })));
}
function $8b6d395814534b36$export$e3ea025983b032e1(a) {
    return $8b6d395814534b36$var$encode($i7mYY.map(a.entries, function(param) {
        return String(param.index);
    }));
}
var $8b6d395814534b36$export$1c37c01eba8ed446 = [
    $8b6d395814534b36$var$t_decode$1,
    $8b6d395814534b36$var$t_encode$1
];
function $8b6d395814534b36$export$7a47376c130cfeac(filters) {
    try {
        var result = $8b6d395814534b36$var$t_decode$1(filters);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return;
    } catch (exn) {
        return;
    }
}
var $8b6d395814534b36$export$3004f64547af360e = $8b6d395814534b36$var$t_decode$1;
var $8b6d395814534b36$export$f84e8e69fd4488a5 = $8b6d395814534b36$var$t_encode$1;
 /* entry_fromJson Not a pure module */ 
});
parcelRegister("3zjNo", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $2993fefbdf26d22c$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "stringToJson", function () { return $2993fefbdf26d22c$export$cb73ac3d868ef79b; });
$parcel$export(module.exports, "stringFromJson", function () { return $2993fefbdf26d22c$export$a8bc34bb3318cfda; });
$parcel$export(module.exports, "intToJson", function () { return $2993fefbdf26d22c$export$dce6a9069b80cba6; });
$parcel$export(module.exports, "intFromJson", function () { return $2993fefbdf26d22c$export$40281f6dcbcf0ee4; });
$parcel$export(module.exports, "floatToJson", function () { return $2993fefbdf26d22c$export$ad575e1229096d23; });
$parcel$export(module.exports, "floatFromJson", function () { return $2993fefbdf26d22c$export$a7e4c9de6f0be695; });
$parcel$export(module.exports, "boolToJson", function () { return $2993fefbdf26d22c$export$1345bb952a2766a4; });
$parcel$export(module.exports, "boolFromJson", function () { return $2993fefbdf26d22c$export$2cacc15469418278; });
$parcel$export(module.exports, "arrayToJson", function () { return $2993fefbdf26d22c$export$fc848dd87fcd545f; });
$parcel$export(module.exports, "arrayFromJson", function () { return $2993fefbdf26d22c$export$5491596feec56301; });
$parcel$export(module.exports, "optionToJson", function () { return $2993fefbdf26d22c$export$ee26ff36a9af215a; });
$parcel$export(module.exports, "optionFromJson", function () { return $2993fefbdf26d22c$export$c52a79ebe572c75; });
$parcel$export(module.exports, "dictToJson", function () { return $2993fefbdf26d22c$export$1875196e68ae0bdf; });
$parcel$export(module.exports, "dictFromJson", function () { return $2993fefbdf26d22c$export$51f094e6554ee1ed; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iAJWt = parcelRequire("iAJWt");

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $5alaa = parcelRequire("5alaa");

var $69lAE = parcelRequire("69lAE");

var $i7mYY = parcelRequire("i7mYY");

var $dD1bi = parcelRequire("dD1bi");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");

var $19caA = parcelRequire("19caA");
function $2993fefbdf26d22c$export$a3bc9b8ed74fc(path, message, value) {
    var path$1 = path !== undefined ? path : "";
    return {
        TAG: /* Error */ 1,
        _0: {
            path: path$1,
            message: message,
            value: value
        }
    };
}
function $2993fefbdf26d22c$export$cb73ac3d868ef79b(s) {
    return s;
}
function $2993fefbdf26d22c$export$a8bc34bb3318cfda(j) {
    var s = $1ArWc.decodeString(j);
    if (s !== undefined) return {
        TAG: /* Ok */ 0,
        _0: s
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a string",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$dce6a9069b80cba6(i) {
    return i;
}
function $2993fefbdf26d22c$export$40281f6dcbcf0ee4(j) {
    var f = $1ArWc.decodeNumber(j);
    if (f !== undefined) {
        if ($5alaa.floor(f) === f) return {
            TAG: /* Ok */ 0,
            _0: $5alaa.floor(f)
        };
        else return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "Not an integer",
                value: j
            }
        };
    } else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a number",
            value: j
        }
    };
}
var $2993fefbdf26d22c$export$e69bf62e5233e775 = $dD1bi.float_of_bits;
function $2993fefbdf26d22c$export$e6b69943c89ad4c4(j) {
    var n = $1ArWc.decodeNumber(j);
    if (n !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $dD1bi.bits_of_float(n)
    };
    else return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a number", j);
}
var $2993fefbdf26d22c$export$6678a7fcc55aad68 = $dD1bi.to_float;
function $2993fefbdf26d22c$export$42c109f7941462bb(j) {
    var n = $1ArWc.decodeNumber(j);
    if (n !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $dD1bi.of_float(n)
    };
    else return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a number", j);
}
function $2993fefbdf26d22c$export$ad575e1229096d23(v) {
    return v;
}
function $2993fefbdf26d22c$export$a7e4c9de6f0be695(j) {
    var f = $1ArWc.decodeNumber(j);
    if (f !== undefined) return {
        TAG: /* Ok */ 0,
        _0: f
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a number",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$1345bb952a2766a4(v) {
    return v;
}
function $2993fefbdf26d22c$export$2cacc15469418278(j) {
    var b = $1ArWc.decodeBoolean(j);
    if (b !== undefined) return {
        TAG: /* Ok */ 0,
        _0: b
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a boolean",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$3565179eec7bd73e(param) {
    return 0.0;
}
function $2993fefbdf26d22c$export$e90afe2f09fcf9b5(param) {
    return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
}
var $2993fefbdf26d22c$export$fc848dd87fcd545f = $69lAE.map;
function $2993fefbdf26d22c$export$5491596feec56301(decoder, json) {
    var arr = $1ArWc.decodeArray(json);
    if (arr !== undefined) return $69lAE.reducei(function(acc, jsonI, i) {
        var match = $iv6Yc._1(decoder, jsonI);
        if (acc.TAG !== /* Ok */ 0) return acc;
        if (match.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: $69lAE.concat([
                match._0
            ], acc._0)
        };
        var error = match._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[" + (String(i) + ("]" + error.path)),
                message: error.message,
                value: error.value
            }
        };
    }, {
        TAG: /* Ok */ 0,
        _0: []
    }, arr);
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not an array",
            value: json
        }
    };
}
function $2993fefbdf26d22c$export$248031d748512657(encoder, list) {
    var arr = $iAJWt.of_list(list);
    return $69lAE.map(encoder, arr);
}
function $2993fefbdf26d22c$export$81588e2d52d5154e(decoder, json) {
    var __x = $2993fefbdf26d22c$export$5491596feec56301(decoder, json);
    return $gTtop.map(__x, $iAJWt.to_list);
}
function $2993fefbdf26d22c$export$ee26ff36a9af215a(encoder, opt) {
    if (opt !== undefined) return $iv6Yc._1(encoder, $loT9g.valFromOption(opt));
    else return null;
}
function $2993fefbdf26d22c$export$c52a79ebe572c75(decoder, json) {
    var match = $1ArWc.decodeNull(json);
    if (match !== undefined) return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
    var __x = $iv6Yc._1(decoder, json);
    return $gTtop.map(__x, function(v) {
        return $loT9g.some(v);
    });
}
function $2993fefbdf26d22c$export$1bfa197d6673cc35(okEncoder, errorEncoder, result) {
    if (result.TAG === /* Ok */ 0) return [
        "Ok",
        $iv6Yc._1(okEncoder, result._0)
    ];
    else return [
        "Error",
        $iv6Yc._1(errorEncoder, result._0)
    ];
}
function $2993fefbdf26d22c$export$e1d2d69b868b65c2(okDecoder, errorDecoder, json) {
    var match = $1ArWc.decodeArray(json);
    if (match === undefined) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not an array", json);
    if (match.length !== 2) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Expected exactly 2 values in array", json);
    var variantConstructorId = match[0];
    var payload = match[1];
    var match$1 = $1ArWc.decodeString(variantConstructorId);
    if (match$1 === undefined) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a string", variantConstructorId);
    switch(match$1){
        case "Error":
            var v = $iv6Yc._1(errorDecoder, payload);
            if (v.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Error */ 1,
                    _0: v._0
                }
            };
            else return {
                TAG: /* Error */ 1,
                _0: v._0
            };
        case "Ok":
            return $gTtop.map($iv6Yc._1(okDecoder, payload), function(v) {
                return {
                    TAG: /* Ok */ 0,
                    _0: v
                };
            });
        default:
            return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, 'Expected either "Ok" or "Error"', variantConstructorId);
    }
}
function $2993fefbdf26d22c$export$1875196e68ae0bdf(encoder, dict) {
    return $d3YYW.map($iv6Yc.__1(encoder), dict);
}
function $2993fefbdf26d22c$export$51f094e6554ee1ed(decoder, json) {
    var dict = $1ArWc.decodeObject(json);
    if (dict !== undefined) return $i7mYY.reduce($d3YYW.entries($loT9g.valFromOption(dict)), {
        TAG: /* Ok */ 0,
        _0: {}
    }, function(acc, param) {
        var key = param[0];
        var match = $iv6Yc._1(decoder, param[1]);
        if (acc.TAG !== /* Ok */ 0) return acc;
        var prev = acc._0;
        if (match.TAG === /* Ok */ 0) {
            prev[key] = match._0;
            return {
                TAG: /* Ok */ 0,
                _0: prev
            };
        }
        var error = match._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "." + (key + error.path),
                message: error.message,
                value: error.value
            }
        };
    });
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a dict",
            value: json
        }
    };
}
var $2993fefbdf26d22c$var$string = [
    $2993fefbdf26d22c$export$cb73ac3d868ef79b,
    $2993fefbdf26d22c$export$a8bc34bb3318cfda
];
var $2993fefbdf26d22c$var$$$int = [
    $2993fefbdf26d22c$export$dce6a9069b80cba6,
    $2993fefbdf26d22c$export$40281f6dcbcf0ee4
];
var $2993fefbdf26d22c$var$int64Unsafe = [
    $2993fefbdf26d22c$export$6678a7fcc55aad68,
    $2993fefbdf26d22c$export$42c109f7941462bb
];
var $2993fefbdf26d22c$var$$$float = [
    $2993fefbdf26d22c$export$ad575e1229096d23,
    $2993fefbdf26d22c$export$a7e4c9de6f0be695
];
var $2993fefbdf26d22c$var$bool = [
    $2993fefbdf26d22c$export$1345bb952a2766a4,
    $2993fefbdf26d22c$export$2cacc15469418278
];
var $2993fefbdf26d22c$var$array = [
    $2993fefbdf26d22c$export$fc848dd87fcd545f,
    $2993fefbdf26d22c$export$5491596feec56301
];
var $2993fefbdf26d22c$var$list = [
    $2993fefbdf26d22c$export$248031d748512657,
    $2993fefbdf26d22c$export$81588e2d52d5154e
];
var $2993fefbdf26d22c$var$option = [
    $2993fefbdf26d22c$export$ee26ff36a9af215a,
    $2993fefbdf26d22c$export$c52a79ebe572c75
];
var $2993fefbdf26d22c$var$unit = [
    $2993fefbdf26d22c$export$3565179eec7bd73e,
    $2993fefbdf26d22c$export$e90afe2f09fcf9b5
];
var $2993fefbdf26d22c$export$1c4d583cbe1d2b10 = {
    falseableEncode: $19caA.falseableEncode,
    falseableDecode: $19caA.falseableDecode,
    falseable: $19caA.falseable,
    magicDecode: $19caA.magicDecode,
    magic: $19caA.magic,
    string: $2993fefbdf26d22c$var$string,
    $$int: $2993fefbdf26d22c$var$$$int,
    int64Unsafe: $2993fefbdf26d22c$var$int64Unsafe,
    $$float: $2993fefbdf26d22c$var$$$float,
    bool: $2993fefbdf26d22c$var$bool,
    array: $2993fefbdf26d22c$var$array,
    list: $2993fefbdf26d22c$var$list,
    option: $2993fefbdf26d22c$var$option,
    unit: $2993fefbdf26d22c$var$unit
};
 /* No side effect */ 
});
parcelRegister("iAJWt", function(module, exports) {

$parcel$export(module.exports, "to_list", function () { return $d88f39f10b164530$export$8e209af3baf60707; });
$parcel$export(module.exports, "of_list", function () { return $d88f39f10b164530$export$b71d4560b1745112; });

var $iv6Yc = parcelRequire("iv6Yc");

var $7bjme = parcelRequire("7bjme");

var $1PGgk = parcelRequire("1PGgk");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");
var $d88f39f10b164530$export$d79c6918e0a9d9af = $1PGgk.make_float;
var $d88f39f10b164530$export$cebbcf13f19bf144 = {};
function $d88f39f10b164530$export$2cd8252107eb640b(l, f) {
    if (l === 0) return [];
    if (l < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.init",
        Error: new Error()
    };
    var res = $1PGgk.make(l, $iv6Yc._1(f, 0));
    for(var i = 1; i < l; ++i)res[i] = $iv6Yc._1(f, i);
    return res;
}
function $d88f39f10b164530$export$4ebb4186b84fa2f7(sx, sy, init) {
    var res = $1PGgk.make(sx, []);
    for(var x = 0; x < sx; ++x)res[x] = $1PGgk.make(sy, init);
    return res;
}
function $d88f39f10b164530$export$784d13d8ee351f07(a) {
    var l = a.length;
    if (l === 0) return [];
    else return $1PGgk.sub(a, 0, l);
}
function $d88f39f10b164530$export$10d8903dec122b9d(a1, a2) {
    var l1 = a1.length;
    if (l1 === 0) return $d88f39f10b164530$export$784d13d8ee351f07(a2);
    else if (a2.length === 0) return $1PGgk.sub(a1, 0, l1);
    else return a1.concat(a2);
}
function $d88f39f10b164530$export$f93b5905241a7cca(a, ofs, len) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.sub",
        Error: new Error()
    };
    return $1PGgk.sub(a, ofs, len);
}
function $d88f39f10b164530$export$9563e054e6f787fb(a, ofs, len, v) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.fill",
        Error: new Error()
    };
    for(var i = ofs, i_finish = ofs + len | 0; i < i_finish; ++i)a[i] = v;
}
function $d88f39f10b164530$export$1b8713e12f56ba52(a1, ofs1, a2, ofs2, len) {
    if (len < 0 || ofs1 < 0 || ofs1 > (a1.length - len | 0) || ofs2 < 0 || ofs2 > (a2.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.blit",
        Error: new Error()
    };
    $1PGgk.blit(a1, ofs1, a2, ofs2, len);
}
function $d88f39f10b164530$export$c0bf298a2e425654(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._1(f, a[i]);
}
function $d88f39f10b164530$export$21f0e7f97cbd7529(f, a, b) {
    if (a.length !== b.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.iter2: arrays must have the same length",
        Error: new Error()
    };
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._2(f, a[i], b[i]);
}
function $d88f39f10b164530$export$871de8747c9eaa88(f, a) {
    var l = a.length;
    if (l === 0) return [];
    var r = $1PGgk.make(l, $iv6Yc._1(f, a[0]));
    for(var i = 1; i < l; ++i)r[i] = $iv6Yc._1(f, a[i]);
    return r;
}
function $d88f39f10b164530$export$5be556bf484c4f10(f, a, b) {
    var la = a.length;
    var lb = b.length;
    if (la !== lb) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.map2: arrays must have the same length",
        Error: new Error()
    };
    if (la === 0) return [];
    var r = $1PGgk.make(la, $iv6Yc._2(f, a[0], b[0]));
    for(var i = 1; i < la; ++i)r[i] = $iv6Yc._2(f, a[i], b[i]);
    return r;
}
function $d88f39f10b164530$export$2827e1b448e826c6(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._2(f, i, a[i]);
}
function $d88f39f10b164530$export$8ef92191dafa99ba(f, a) {
    var l = a.length;
    if (l === 0) return [];
    var r = $1PGgk.make(l, $iv6Yc._2(f, 0, a[0]));
    for(var i = 1; i < l; ++i)r[i] = $iv6Yc._2(f, i, a[i]);
    return r;
}
function $d88f39f10b164530$export$8e209af3baf60707(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) return res;
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$var$list_length(_accu, _param) {
    while(true){
        var param = _param;
        var accu = _accu;
        if (!param) return accu;
        _param = param.tl;
        _accu = accu + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$b71d4560b1745112(l) {
    if (!l) return [];
    var a = $1PGgk.make($d88f39f10b164530$var$list_length(0, l), l.hd);
    var _i = 1;
    var _param = l.tl;
    while(true){
        var param = _param;
        var i = _i;
        if (!param) return a;
        a[i] = param.hd;
        _param = param.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$887fcf96d740879c(f, x, a) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = $iv6Yc._2(f, r, a[i]);
    return r;
}
function $d88f39f10b164530$export$d98553ecae3b472f(f, a, x) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i)r = $iv6Yc._2(f, a[i], r);
    return r;
}
function $d88f39f10b164530$export$f7e9f41ea797a17(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if ($iv6Yc._1(p, a[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$b276b5448e887371(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return true;
        if (!$iv6Yc._1(p, a[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$e8308fa57e490f0c(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if ($7bjme.equal(a[i], x)) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$922408a699a56fa1(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if (x === a[i]) return true;
        _i = i + 1 | 0;
        continue;
    }
}
var $d88f39f10b164530$var$Bottom = /* @__PURE__ */ $1xvYg.create("Array.Bottom");
function $d88f39f10b164530$export$97db5808d8f88186(cmp, a) {
    var maxson = function maxson(l, i) {
        var i31 = ((i + i | 0) + i | 0) + 1 | 0;
        var x = i31;
        if ((i31 + 2 | 0) < l) {
            if ($iv6Yc._2(cmp, $1PGgk.get(a, i31), $1PGgk.get(a, i31 + 1 | 0)) < 0) x = i31 + 1 | 0;
            if ($iv6Yc._2(cmp, $1PGgk.get(a, x), $1PGgk.get(a, i31 + 2 | 0)) < 0) x = i31 + 2 | 0;
            return x;
        }
        if ((i31 + 1 | 0) < l && $iv6Yc._2(cmp, $1PGgk.get(a, i31), $1PGgk.get(a, i31 + 1 | 0)) < 0) return i31 + 1 | 0;
        if (i31 < l) return i31;
        throw {
            RE_EXN_ID: $d88f39f10b164530$var$Bottom,
            _1: i,
            Error: new Error()
        };
    };
    var trickle = function trickle(l, i, e) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                if ($iv6Yc._2(cmp, $1PGgk.get(a, j), e) <= 0) return $1PGgk.set(a, i$1, e);
                $1PGgk.set(a, i$1, $1PGgk.get(a, j));
                _i = j;
                continue;
            }
        } catch (raw_i) {
            var i$2 = $bBMv4.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === $d88f39f10b164530$var$Bottom) return $1PGgk.set(a, i$2._1, e);
            throw i$2;
        }
    };
    var bubble = function bubble(l, i) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                $1PGgk.set(a, i$1, $1PGgk.get(a, j));
                _i = j;
                continue;
            }
        } catch (raw_i) {
            var i$2 = $bBMv4.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === $d88f39f10b164530$var$Bottom) return i$2._1;
            throw i$2;
        }
    };
    var trickleup = function trickleup(_i, e) {
        while(true){
            var i = _i;
            var father = (i - 1 | 0) / 3 | 0;
            if (i === father) throw {
                RE_EXN_ID: "Assert_failure",
                _1: [
                    "array.ml",
                    236,
                    4
                ],
                Error: new Error()
            };
            if ($iv6Yc._2(cmp, $1PGgk.get(a, father), e) >= 0) return $1PGgk.set(a, i, e);
            $1PGgk.set(a, i, $1PGgk.get(a, father));
            if (father <= 0) return $1PGgk.set(a, 0, e);
            _i = father;
            continue;
        }
    };
    var l = a.length;
    for(var i = ((l + 1 | 0) / 3 | 0) - 1 | 0; i >= 0; --i)trickle(l, i, $1PGgk.get(a, i));
    for(var i$1 = l - 1 | 0; i$1 >= 2; --i$1){
        var e = $1PGgk.get(a, i$1);
        $1PGgk.set(a, i$1, $1PGgk.get(a, 0));
        trickleup(bubble(i$1, 0), e);
    }
    if (l <= 1) return;
    var e$1 = $1PGgk.get(a, 1);
    $1PGgk.set(a, 1, $1PGgk.get(a, 0));
    $1PGgk.set(a, 0, e$1);
}
function $d88f39f10b164530$export$a1529f83f7b416e0(cmp, a) {
    var merge = function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
        var src1r = src1ofs + src1len | 0;
        var src2r = src2ofs + src2len | 0;
        var _i1 = src1ofs;
        var _s1 = $1PGgk.get(a, src1ofs);
        var _i2 = src2ofs;
        var _s2 = $1PGgk.get(src2, src2ofs);
        var _d = dstofs;
        while(true){
            var d = _d;
            var s2 = _s2;
            var i2 = _i2;
            var s1 = _s1;
            var i1 = _i1;
            if ($iv6Yc._2(cmp, s1, s2) <= 0) {
                $1PGgk.set(dst, d, s1);
                var i1$1 = i1 + 1 | 0;
                if (i1$1 >= src1r) return $d88f39f10b164530$export$1b8713e12f56ba52(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                _d = d + 1 | 0;
                _s1 = $1PGgk.get(a, i1$1);
                _i1 = i1$1;
                continue;
            }
            $1PGgk.set(dst, d, s2);
            var i2$1 = i2 + 1 | 0;
            if (i2$1 >= src2r) return $d88f39f10b164530$export$1b8713e12f56ba52(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
            _d = d + 1 | 0;
            _s2 = $1PGgk.get(src2, i2$1);
            _i2 = i2$1;
            continue;
        }
    };
    var isortto = function isortto(srcofs, dst, dstofs, len) {
        for(var i = 0; i < len; ++i){
            var e = $1PGgk.get(a, srcofs + i | 0);
            var j = (dstofs + i | 0) - 1 | 0;
            while(j >= dstofs && $iv6Yc._2(cmp, $1PGgk.get(dst, j), e) > 0){
                $1PGgk.set(dst, j + 1 | 0, $1PGgk.get(dst, j));
                j = j - 1 | 0;
            }
            $1PGgk.set(dst, j + 1 | 0, e);
        }
    };
    var sortto = function sortto1(srcofs, dst, dstofs, len) {
        if (len <= 5) return isortto(srcofs, dst, dstofs, len);
        var l1 = len / 2 | 0;
        var l2 = len - l1 | 0;
        sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
        sortto(srcofs, a, srcofs + l2 | 0, l1);
        merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
    };
    var l = a.length;
    if (l <= 5) return isortto(0, a, 0, l);
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = $1PGgk.make(l2, $1PGgk.get(a, 0));
    sortto(l1, t, 0, l2);
    sortto(0, a, l2, l1);
    merge(l2, l1, t, 0, l2, a, 0);
}
var $d88f39f10b164530$export$fbdae951ea4eb733 = $d88f39f10b164530$export$4ebb4186b84fa2f7;
var $d88f39f10b164530$export$ee1b3e54f0441b22 = $1PGgk.concat;
var $d88f39f10b164530$export$9e7eab3675a60000 = $d88f39f10b164530$export$a1529f83f7b416e0;
 /* No side effect */ 
});

parcelRegister("69lAE", function(module, exports) {

$parcel$export(module.exports, "sortInPlaceWith", function () { return $47a454af396e700b$export$156a0843b24294c7; });
$parcel$export(module.exports, "concat", function () { return $47a454af396e700b$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "joinWith", function () { return $47a454af396e700b$export$ec1dc8fbeea3467e; });
$parcel$export(module.exports, "map", function () { return $47a454af396e700b$export$871de8747c9eaa88; });
$parcel$export(module.exports, "reducei", function () { return $47a454af396e700b$export$1460fbe8fbaef9f6; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $e1M2F = parcelRequire("e1M2F");
function $47a454af396e700b$export$10074e8e319eaaf(to_, obj) {
    return obj.copyWithin(to_);
}
function $47a454af396e700b$export$a9411e2b2f73668a(to_, from, obj) {
    return obj.copyWithin(to_, from);
}
function $47a454af396e700b$export$50c2501df62a61c3(to_, start, end_, obj) {
    return obj.copyWithin(to_, start, end_);
}
function $47a454af396e700b$export$3e23afb5fa975f92(arg1, obj) {
    return obj.fill(arg1);
}
function $47a454af396e700b$export$7c8a9f335867b105(arg1, from, obj) {
    return obj.fill(arg1, from);
}
function $47a454af396e700b$export$118900df563279e9(arg1, start, end_, obj) {
    return obj.fill(arg1, start, end_);
}
function $47a454af396e700b$export$4cbf152802aa238(arg1, obj) {
    return obj.push(arg1);
}
function $47a454af396e700b$export$9b635950ada85578(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "push", [
        arg1
    ]);
}
function $47a454af396e700b$export$156a0843b24294c7(arg1, obj) {
    return obj.sort($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$2e896601dcb17d26(pos, remove, add, obj) {
    return $e1M2F.spliceObjApply(obj, "splice", [
        pos,
        remove,
        add
    ]);
}
function $47a454af396e700b$export$38d7b11c94e4a8d6(pos, obj) {
    return obj.splice(pos);
}
function $47a454af396e700b$export$557eb37c4229d889(pos, count, obj) {
    return obj.splice(pos, count);
}
function $47a454af396e700b$export$37cdb546b806ae87(arg1, obj) {
    return obj.unshift(arg1);
}
function $47a454af396e700b$export$8fc1d85e1f2cc952(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "unshift", [
        arg1
    ]);
}
function $47a454af396e700b$export$ee1b3e54f0441b22(arg1, obj) {
    return obj.concat(arg1);
}
function $47a454af396e700b$export$252d63de73a739bf(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function $47a454af396e700b$export$ee2e0f811dca1807(arg1, obj) {
    return obj.includes(arg1);
}
function $47a454af396e700b$export$305f7d4e9d4624f2(arg1, obj) {
    return obj.indexOf(arg1);
}
function $47a454af396e700b$export$3840751aad9a3d1c(arg1, from, obj) {
    return obj.indexOf(arg1, from);
}
function $47a454af396e700b$export$ec1dc8fbeea3467e(arg1, obj) {
    return obj.join(arg1);
}
function $47a454af396e700b$export$557cfb7ed375eeb7(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function $47a454af396e700b$export$4a78c614e5d162c5(arg1, from, obj) {
    return obj.lastIndexOf(arg1, from);
}
function $47a454af396e700b$export$58adb3bec8346d0f(start, end_, obj) {
    return obj.slice(start, end_);
}
function $47a454af396e700b$export$a6d937cf5d2f468f(arg1, obj) {
    return obj.slice(arg1);
}
function $47a454af396e700b$export$7ecc1a3b11b57dab(arg1, obj) {
    return obj.every($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$17d08d18d8b01471(arg1, obj) {
    return obj.every($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$3dea766d36a8935f(arg1, obj) {
    return obj.filter($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$c31b87d65f96e3d5(arg1, obj) {
    return obj.filter($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$71aa6c912b956294(arg1, obj) {
    return $loT9g.undefined_to_opt(obj.find($iv6Yc.__1(arg1)));
}
function $47a454af396e700b$export$14909f539c3e1215(arg1, obj) {
    return $loT9g.undefined_to_opt(obj.find($iv6Yc.__2(arg1)));
}
function $47a454af396e700b$export$de3a4d4a0d731119(arg1, obj) {
    return obj.findIndex($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$777fa43736d5bf3f(arg1, obj) {
    return obj.findIndex($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$4b80e395e36b5a56(arg1, obj) {
    obj.forEach($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$3ab1c29810397d(arg1, obj) {
    obj.forEach($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$871de8747c9eaa88(arg1, obj) {
    return obj.map($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$8ef92191dafa99ba(arg1, obj) {
    return obj.map($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$533b26079ad0b4b(arg1, arg2, obj) {
    return obj.reduce($iv6Yc.__2(arg1), arg2);
}
function $47a454af396e700b$export$1460fbe8fbaef9f6(arg1, arg2, obj) {
    return obj.reduce($iv6Yc.__3(arg1), arg2);
}
function $47a454af396e700b$export$7fef8bcdbb34f435(arg1, arg2, obj) {
    return obj.reduceRight($iv6Yc.__2(arg1), arg2);
}
function $47a454af396e700b$export$4f1bdf2a9013c4b6(arg1, arg2, obj) {
    return obj.reduceRight($iv6Yc.__3(arg1), arg2);
}
function $47a454af396e700b$export$ad14ef4001db2bcd(arg1, obj) {
    return obj.some($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$de945d66ae7365ca(arg1, obj) {
    return obj.some($iv6Yc.__2(arg1));
}
 /* No side effect */ 
});

parcelRegister("19caA", function(module, exports) {

$parcel$export(module.exports, "falseableEncode", function () { return $0d601263f4f6eea3$export$56a34f49e946fb8d; });
$parcel$export(module.exports, "falseableDecode", function () { return $0d601263f4f6eea3$export$79fc6ebce6085d4; });
$parcel$export(module.exports, "falseable", function () { return $0d601263f4f6eea3$export$7e1b4c12916ef62d; });
$parcel$export(module.exports, "magicDecode", function () { return $0d601263f4f6eea3$export$560896e1f267396b; });
$parcel$export(module.exports, "magic", function () { return $0d601263f4f6eea3$export$13db3bb8db75f394; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $1ArWc = parcelRequire("1ArWc");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");
function $0d601263f4f6eea3$export$56a34f49e946fb8d(encoder, opt) {
    if (opt !== undefined) return $iv6Yc._1(encoder, $loT9g.valFromOption(opt));
    else return false;
}
function $0d601263f4f6eea3$export$79fc6ebce6085d4(decoder, json) {
    var match = $1ArWc.decodeBoolean(json);
    if (match !== undefined && !match) return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
    var __x = $iv6Yc._1(decoder, json);
    return $gTtop.map(__x, function(v) {
        return $loT9g.some(v);
    });
}
var $0d601263f4f6eea3$export$7e1b4c12916ef62d = [
    $0d601263f4f6eea3$export$56a34f49e946fb8d,
    $0d601263f4f6eea3$export$79fc6ebce6085d4
];
function $0d601263f4f6eea3$export$560896e1f267396b(j) {
    return {
        TAG: /* Ok */ 0,
        _0: j
    };
}
function $0d601263f4f6eea3$var$magic_0(prim) {
    return prim;
}
var $0d601263f4f6eea3$export$13db3bb8db75f394 = [
    $0d601263f4f6eea3$var$magic_0,
    $0d601263f4f6eea3$export$560896e1f267396b
];
 /* No side effect */ 
});



parcelRegister("04dLg", function(module, exports) {

$parcel$export(module.exports, "ProductSortOrder", function () { return $00cb0c920b5246fc$export$1fffe7771e220b3d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $AAkl8 = parcelRequire("AAkl8");

var $kM5sF = parcelRequire("kM5sF");
function $00cb0c920b5246fc$var$toJson(sortOrder) {
    switch(sortOrder){
        case /* Default */ 0:
            return $AAkl8.array([
                "Default"
            ], $AAkl8.string);
        case /* Featured */ 1:
            return $AAkl8.array([
                "Featured"
            ], $AAkl8.string);
        case /* BestSellers */ 2:
            return $AAkl8.array([
                "BestSellers"
            ], $AAkl8.string);
        case /* Newest */ 3:
            return $AAkl8.array([
                "Newest"
            ], $AAkl8.string);
        case /* HighestPrice */ 4:
            return $AAkl8.array([
                "HighestPrice"
            ], $AAkl8.string);
        case /* LowestPrice */ 5:
            return $AAkl8.array([
                "LowestPrice"
            ], $AAkl8.string);
        case /* HighestDiscount */ 6:
            return $AAkl8.array([
                "HighestDiscount"
            ], $AAkl8.string);
    }
}
var $00cb0c920b5246fc$var$fromJson = $kM5sF.ProductSortOrder.fromJson;
var $00cb0c920b5246fc$var$all = $kM5sF.ProductSortOrder.all;
var $00cb0c920b5246fc$var$fromString = $kM5sF.ProductSortOrder.fromString;
function $00cb0c920b5246fc$var$toString(sort) {
    switch(sort){
        case /* Default */ 0:
            return "default";
        case /* Featured */ 1:
            return "featured";
        case /* BestSellers */ 2:
            return "best_sellers";
        case /* Newest */ 3:
            return "newest";
        case /* HighestPrice */ 4:
            return "highest_price";
        case /* LowestPrice */ 5:
            return "lowest_price";
        case /* HighestDiscount */ 6:
            return "highest_discount";
    }
}
var $00cb0c920b5246fc$export$1fffe7771e220b3d = {
    toJson: $00cb0c920b5246fc$var$toJson,
    fromJson: $00cb0c920b5246fc$var$fromJson,
    all: $00cb0c920b5246fc$var$all,
    fromString: $00cb0c920b5246fc$var$fromString,
    toString: $00cb0c920b5246fc$var$toString
};
 /* Json__Encode Not a pure module */ 
});
parcelRegister("kM5sF", function(module, exports) {

$parcel$export(module.exports, "ProductSortOrder", function () { return $f1fc86dab33de118$export$1fffe7771e220b3d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");
var $f1fc86dab33de118$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Featured",
        /* Featured */ 1
    ],
    [
        "BestSellers",
        /* BestSellers */ 2
    ],
    [
        "Newest",
        /* Newest */ 3
    ],
    [
        "HighestPrice",
        /* HighestPrice */ 4
    ],
    [
        "LowestPrice",
        /* LowestPrice */ 5
    ],
    [
        "HighestDiscount",
        /* HighestDiscount */ 6
    ]
]);
var $f1fc86dab33de118$var$all = [
    /* Default */ 0,
    /* Featured */ 1,
    /* BestSellers */ 2,
    /* Newest */ 3,
    /* HighestPrice */ 4,
    /* LowestPrice */ 5
];
function $f1fc86dab33de118$var$fromString(str) {
    switch(str){
        case "best_sellers":
            return /* BestSellers */ 2;
        case "default":
            return /* Default */ 0;
        case "featured":
            return /* Featured */ 1;
        case "highest_discount":
            return /* HighestDiscount */ 6;
        case "highest_price":
            return /* HighestPrice */ 4;
        case "lowest_price":
            return /* LowestPrice */ 5;
        case "newest":
            return /* Newest */ 3;
        default:
            return /* Default */ 0;
    }
}
var $f1fc86dab33de118$export$1fffe7771e220b3d = {
    fromJson: $f1fc86dab33de118$var$fromJson,
    all: $f1fc86dab33de118$var$all,
    fromString: $f1fc86dab33de118$var$fromString
};
 /* fromJson Not a pure module */ 
});


})();
//# sourceMappingURL=ConfigurationDecoder.bs.efd81eca.js.map
